// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"91f0b660","213":"610585ec","453":"082eee73","455":"fce0baf5","967":"1f103d87"}[chunkId] + ".chunk.js";
};